'use client';
/**
 * s-log — 확정 검색 비콘(클라이언트). 검색창 컴포넌트(헤더·히어로·/search·지역 허브 — s-ui kd-gs)가 «이것만» 부른다.
 *   · logSelection  — 제안 항목을 골랐을 때: v2-log 1행 + 선택(slug·rank) 한 요청. Enter 는 부르지 않는다(결과 페이지가 1행).
 *   · confirmPage   — /search 결과 페이지 마운트 1회: 서버 렌더가 남긴 행을 이 세션으로 확정(SearchConfirmLogger).
 *   · logResultClick — 결과 페이지에서 결과를 눌렀을 때 같은 행 update.
 * 키 입력마다 부르는 함수는 없다(키 입력 기록 0).
 */
import { searchSessionId } from './use-search-suggest';

function post(url: string, body: unknown): Promise<Response | null> {
  return fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body), keepalive: true }).catch(() => null);
}

async function idOf(r: Response | null): Promise<string | null> {
  if (!r || !r.ok) return null;
  const j = await r.json().catch(() => null);
  return typeof j?.logId === 'string' ? j.logId : null;
}

export interface SelectionLog {
  q: string;
  count: number;
  source: string;
  slug: string;
  rank: number;
  region?: string | null;
  latencyMs?: number | null;
}

/** 제안 선택 = 확정 검색 1행 + 같은 행 선택 기록. */
export async function logSelection(s: SelectionLog): Promise<string | null> {
  const q = (s.q ?? '').trim();
  if (!q || !s.slug || !(s.rank >= 1)) return null;
  // 한 요청(keepalive) — 서버가 같은 행에 선택까지 쓴다(곧바로 페이지를 떠나도 남는다).
  return idOf(await post('/api/search/v2-log', {
    q, count: s.count, latencyMs: s.latencyMs ?? 0, source: s.source, sid: searchSessionId(), region: s.region ?? null,
    slug: s.slug, rank: s.rank,
  }));
}

export async function confirmPage(p: { q: string; count: number; source: string; region?: string | null; near?: boolean; latencyMs?: number | null }): Promise<string | null> {
  return idOf(await post('/api/search/v2-log', {
    q: p.q, count: p.count, source: p.source, sid: searchSessionId(), region: p.region ?? null, near: p.near === true,
    latencyMs: p.latencyMs ?? 0, confirm: true,
  }));
}

export function logResultClick(logId: string | null, slug: string | null, rank: number): void {
  if (!logId || !slug || !(rank >= 1)) return;
  void post('/api/search/selected', { logId, slug, rank });
}
